<template>
  <div>
    <template v-if="disabled">
      {{ data }}
    </template>
    <!-- class="demo-inline-spacing" class="form-control"

      :placeholder="$t('_components.placeholder.select')+label"-->
    <a-range-picker
      v-else
      :placeholder="['Start month', 'End month']"
      format="YYYY-MM"
      size="large"
      :value="value"
      :mode="['month','month']"
      @panelChange="handlePanelChange"
      @change="handleChange"
    />
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: () => [],
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: [],
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        // 用于清空选择器
        if (!e) {
          this.data = []
        }
      },
      deep: true,
    },
  },
  methods: {
    handleChange(value, dateStrings) {
    //   this.data = value;
    },
    handlePanelChange(value) {
      const valus = [value[0].format('YYYY-MM'), value[1].format('YYYY-MM')]
      this.data = valus;
    },
    // dateChange(dates, dateStrings) {
    //   this.data = dateStrings
    // },
  },
}

</script>

<style lang='scss'>
.form-control{
    height: 100%;
    width: 100%;
    margin:0
}
</style>
